import { memo } from "react";
import { CX, CY } from "./MainArc";

const R_OUTER = 65;
const R_INNER = 50;
const CIRCUMFERENCE = 2 * Math.PI * R_INNER;

type Props = {
  speed: number;
  unit: string;
  maxSpeed: number;
};

export const CenterReadout = memo(function CenterReadout({ speed, unit, maxSpeed }: Props) {
  const fraction = Math.min(Math.max(speed / maxSpeed, 0), 1);

  return (
    <>
      {/* Outer ring */}
      <circle
        cx={CX}
        cy={CY}
        r={R_OUTER}
        fill="none"
        stroke="rgba(255,255,255,0.05)"
        strokeWidth="1.5"
      />

      {/* Inner ring — gray base */}
      <circle
        cx={CX}
        cy={CY}
        r={R_INNER}
        fill="none"
        stroke="rgba(255,255,255,0.15)"
        strokeWidth="3"
      />
      {/* Inner ring — blue speed progress */}
      <circle
        cx={CX}
        cy={CY}
        r={R_INNER}
        fill="none"
        stroke="#58BCFF"
        strokeWidth="3"
        strokeDasharray={CIRCUMFERENCE}
        strokeDashoffset={CIRCUMFERENCE * (1 - fraction)}
        strokeLinecap="round"
        transform={`rotate(-90, ${CX}, ${CY})`}
      />

      {/* Speed number */}
      <text
        x={CX}
        y={CY + 4}
        textAnchor="middle"
        dominantBaseline="auto"
        fill="#ffffff"
        fontSize="37"
        fontWeight="600"
        className="purista-font"
      >
        {speed?.toFixed(0)}
      </text>
      {/* Unit label */}
      <text
        x={CX}
        y={CY + 11}
        textAnchor="middle"
        dominantBaseline="hanging"
        fill="rgba(255,255,255,0.45)"
        fontSize="20"
        fontWeight="300"
        letterSpacing="0"
        className="purista-font uppercase"
      >
        {unit}
      </text>
    </>
  );
});
